import { createContext } from 'react';

const courseContext = createContext();

export default courseContext;
